import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  aiAssistantContainer: {
    backgroundColor: theme.palette.grey[100],
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minWidth: 280,
    overflow: 'auto',
    width: '100%'
  },
  leftHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1)
  }
}));
